import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { reportReorderReport } from 'utils/breadcrumbInfo';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import Pagination from 'screens/components/basic/Pagination';
import { getProductTypes } from 'actions/EntityActions';
import { getReorderReport, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Grid from 'screens/components/basic/Grid';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import WithRouter from 'custom/withRouter';


class ReOrderReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()

        this.props.formInput(date, `ReOrderReportSelectedDate`);
        if (localStorage.getItem("ReOrderReportCsvColumns") != null) {
            this.props.formInput(localStorage.getItem("ReOrderReportCsvColumns").split(","), "ReOrderReportCsvColumns")
        }

        this.props.getProductTypes();

    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedCsvColumns != undefined && this.props.selectedCsvColumns != prevProps.selectedCsvColumns) {
            localStorage.setItem("ReOrderReportCsvColumns", this.props.selectedCsvColumns)
        }
    }

    getReport = () => {
        let branch = this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch;
        let method = this.props.method ? this.props.method : '1';
        let selectedDate = this.props.selectedDate || moment().format("YYYY-MM-DD");
        let productId = 0;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let category = this.props.category ? this.props.category : '0';
        let selectedcategory = this.props.selectedCategory ? this.props.selectedCategory : "0";
        let numOfWeeks = this.props.numOfWeeks ? this.props.numOfWeeks : '1';
        let poFrequency = this.props.poFrequency ? this.props.poFrequency : "1"
        let weight = this.props.weight ? this.props.weight : "0";
        let species = this.props.species ? this.props.species : "0";
        let hideZero = this.props.hideZero;
        this.props.getReorderReport({ branch, selectedDate, productId, pageNumber, pageSize, selectedcategory, method, category, numOfWeeks, poFrequency, weight, species, hideZero });
    }

    downloadReport = () => {
        let branch = this.props.selectedBranch;
        let selectedDate = this.props.selectedDate;
        let productId = 0;
        let pageNumber = 1;
        let pageSize = 9999;
        let selectedcategory = this.props.selectedCategory ? this.props.selectedCategory : "0";
        let method = this.props.method ? this.props.method : '1';
        let category = this.props.category ? this.props.category : '0';
        let numOfWeeks = this.props.numOfWeeks ? this.props.numOfWeeks : '1';
        let poFrequency = this.props.poFrequency ? this.props.poFrequency : "1"
        let weight = this.props.weight ? this.props.weight : "0";
        let species = this.props.species ? this.props.species : "0";
        let hideZero = this.props.hideZero;
        let selectedCsvColumns = this.props.selectedCsvColumns.map(item => item.value) || [];

        let allCsvColumns = this.props.csvColumnOptions.map(item => item.value)
        let selectedColumnsInOrder = allCsvColumns.filter(item => selectedCsvColumns.includes(item)).join(",");

        this.props.getCsvReport(`reports/excel/reorder?branch=${branch}&selectedDate=${selectedDate}&selectedcategory=${selectedcategory}&method=${method}&category=${category}&weightoption=${weight}&numOfWeeks=${numOfWeeks}&poFrequency=${poFrequency}&productId=${productId}&species=${species}&pageNumber=${pageNumber}&pageSize=${pageSize}&hideZero=${hideZero}&selectedCsvColumns=${selectedColumnsInOrder}`, "reorderreport");
    }



    redirectToReport = () => {
        this.props.navigate("/report");
    }

    cleanSearch = () => {
        this.props.clearFormInput(`InventoryLevelWarehouse`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        this.filter();
        this.setState({ showBody: true });
    }

    formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }


    render() {
        let productcategories = [];
        productcategories.push({ text: "All", value: "0" });
        const cat = this.props.productTypes.length > 0 ? this.props.productTypes[0].categories : [];
        cat.map(item => {
            productcategories.push({
                text: item.name,
                value: item.id.toString()
            });
        });

        productcategories.sort((a, b) => {
            if (a.text < b.text)
                return -1;
            if (a.text > b.text)
                return 1;
            return 0;
        });

        return (
            <Grid headerContent={reportReorderReport}>
                <PageHeader 
                    title={LOOKUP.report.reorderReport.text} 
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-re-order-report" />}
                    description={LOOKUP.report.reorderReport.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    methods={this.props.methods}
                    categories={this.props.categories}
                    productcategories={productcategories}
                    weightOptions={this.props.weightOptions}
                    numOfWeeksOptions={this.props.numOfWeeksOptions}
                    loggedBranch={this.props.loggedBranch}
                    speciesOptions={this.props.speciesOptions}
                    csvColumnOptions={this.props.csvColumnOptions}
                />
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body reorder={this.props.reorder} selectedDate={this.props.selectedDate} history={this.props.orderredHistory}
                            numOfWeeks={this.props.numOfWeeks} poFrequency={this.props.poFrequency} />

                        <Pagination
                            length={this.props.reorder ? this.props.reorder.total : 0}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        )
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    let Methods =
        [
            {
                text: "Value Sold", value: "1"
            },
            {
                text: "Items Sold", value: "2"
            },
            {
                text: "Items Running low", value: "3"
            }
        ]

    let categories =
        [
            {
                text: "All", value: "0"
            },
            {
                text: "Cannabis", value: "1"
            },
            {
                text: "Non-Cannabis", value: "2"
            }
        ]
    let numOfWeeksOptions =
        [
            {
                text: "One Week", value: "1"
            },
            {
                text: "Two Weeks", value: "2"
            },
            {
                text: "Three Weeks", value: "3"
            },
            {
                text: "Four Weeks", value: "4"
            },
            {
                text: "Two Months", value: "9"
            },
            {
                text: "Three Months", value: "13"
            },
            {
                text: "Four Months", value: "17"
            }
        ]
    let weightoptions = [
        {
            text: "All", value: "0"
        },
        {
            text: "1G", value: "1"
        },
        {
            text: "3.5G", value: "3.5"
        },
        {
            text: "7G", value: "7"
        },
        {
            text: "14G", value: "14"
        },
        {
            text: "15G", value: "15"
        },
        {
            text: "28G", value: "28"
        }
    ];
    let speciesOptions = [
        {
            text: "All", value: "0"
        },
        {
            text: "Indica", value: "1"
        },
        {
            text: "Hybrid", value: "2"
        },
        {
            text: "Sativa", value: "3"
        },
        {
            text: "CBD", value: "4"
        },
        {
            text: "Blend", value: "5"
        },
        {
            text: "Others", value: "6"
        }
    ];

    let csvColumns = [
        { text: "BranchId", value: "BranchId" },
        { text: "BranchName", value: "BranchName" },
        { text: "ProductId", value: "ProductId" },
        { text: "Product Name", value: "ProductName" },
        { text: "Brand", value: "Brand" },
        { text: "SKU", value: "SKU" },
        { text: "Category", value: "Category" },
        { text: "Species", value: "Species" },
        { text: "THC Level", value: "THC_Level" },
        { text: "CBD level", value: "CBD_Level" },
        { text: "First Order Date", value: "FirstOrderDate" },
        { text: "Most Recent Order Date", value: "MostRecentOrderDate" },
        { text: "Days In Stock", value: "DaysInStock" },
        { text: "Velocity", value: "Velocity" },
        { text: "Time to Sell Ten", value: "TimetoSellTen" },
        { text: "Profit Margin", value: "ProfitMargin" },
        { text: "Price", value: "Price" },
        { text: "Sold Last Period", value: "SoldLastPeriod" },
        { text: "Value Sold", value: "ValueSold" },
        { text: "Avg Qty Sold Per Day", value: "AvgQtySoldPerDay" },
        { text: "Lifetime Qty Sold", value: "LifetimeQtySold" },
        { text: "Current Inventory", value: "CurrentInventoryStoreStorage" },
        { text: "Estimated Inventory NextWeek", value: "EstimatedInventoryNextWeek" },
        { text: "Weeks Remaining Until Stockout", value: "WeeksRemainingUntilStockout" },
        { text: "Restock Cap", value: "RestockCap" },
        { text: "Estimated Order Quantity", value: "EstimatedOrderQty" },
        { text: "PO Quantity Opened", value: "POquantityOpened" },
        { text: "PO Quantity OnOrder", value: "POquantityOnOrder" },
    ];
    return {
        brachOptions: brachOptions,
        selectedBranch: state.form.ReOrderReportBranchOption,
        selectedDate: moment(state.form.ReOrderReportSelectedDate).format("YYYY-MM-DD"),
        loggedBranch: state.common.branchId,
        reorder: state.reports.reorder,
        methods: Methods,
        productTypes: state.entity.productTypesList,
        selectedCategory: state.form.ReOrderReportSelectedCategory,
        categories: categories,
        method: state.form.ReOrderReportMethods,
        weight: state.form.ReOrderReportWeight,
        category: state.form.ReOrderReportCategory,
        numOfWeeks: state.form.ReOrderReportNumOfWeeks,
        poFrequency: state.form.ReOrderReportPOFrequency,
        orderredHistory: state.form.ReOrderReportSinceInception,
        hideZero: state.form.ReOrderReportHideZero,
        weightOptions: weightoptions,
        speciesOptions: speciesOptions,
        species: state.form.ReOrderReportSpecies,
        numOfWeeksOptions,
        csvColumnOptions: csvColumns,
        selectedCsvColumns: state.form.ReOrderReportCsvColumns
    };
};

const mapDispatchToProps = dispatch => {

    return {
        getReorderReport: (model) => dispatch(getReorderReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getProductTypes: () => dispatch(getProductTypes()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(ReOrderReport));